import { filter, find, go, head, html, map, pluck, sel, strMap } from 'fxjs/es';
import { NessLabsSettingConstantS } from '../Constant/module/NessLabsSettingConstantS.js';
import $dataStr from 'fxdom/es/dataStr.js';
import { MShopUtilF } from '../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { NessCustomMakerFrameShareTmplS } from '../../../../NessCustomMaker/Frame/Share/S/Tmpl/module/NessCustomMakerFrameShareTmplS.js';
import { UtilTmplS } from '../../../../Util/S/Tmpl/module/UtilTmplS.js';
import { NessLabsS } from '../../../S/Function/module/NessLabsS.js';
import { UtilS } from '../../../../Util/S/Function/module/UtilS.js';
import { NessLabsSettingS } from '../Function/module/NessLabsSettingS.js';

export const ControlSection = {
  makeFrameSelect: (frame_option, selected_frame_no) => {
    const { min_frame_no, max_frame_no } = frame_option;
    const value = selected_frame_no || min_frame_no;
    const name = NessLabsSettingS.numberToLetter(value);

    return html` <div
      class="motion-select motion-frame-select ${min_frame_no === max_frame_no ? 'disabled' : ''}"
      data-fx-json="${$dataStr(frame_option)}"
    >
      ${makeSelectedOptionHtml({
        value,
        name,
        frame_option: true,
      })}
    </div>`;
  },
  makeSelect: (options, selected_motion_id, type) => {
    const value = selected_motion_id || NessLabsSettingConstantS.DEFAULT_MOTIONS[type];
    const name = go(
      options,
      find(({ motion_id }) => motion_id === value),
      sel('name'),
    );

    return html`
      <div class="motion-select" data-fx-json="${$dataStr(options)}">
        ${makeSelectedOptionHtml({
          value,
          name,
        })}
      </div>
    `;
  },

  make: (type, selected_value, options) => {
    if (!options.length) {
      console.error('가능한 모션 없음!');
      return '';
    }

    const title = type.charAt(0) + type.slice(1).toLowerCase();
    const is_weapon = type === NessLabsSettingConstantS.MOTION_TYPES.WEAPON;

    // 사용하지 않는 액션인 경우 첫번째 액션으로 강제
    if (!pluck('motion_id', options).includes(selected_value.id)) {
      const { available_frame } = head(options);
      selected_value = {
        id: available_frame.id,
        frame_no: available_frame.min_frame_no,
      };
    }

    const selected = go(
      options,
      find(({ motion_id }) => motion_id === selected_value?.id),
    );

    return html`
      <div class="control-section" data-type="${type}">
        <h3>${title}</h3>
        <div class="control-section__selectes">
          ${ControlSection.makeSelect(options, selected_value.id, type)}
          ${UtilS.htmlIf(
            !is_weapon,
            ControlSection.makeFrameSelect(selected.available_frame, selected_value.frame_no),
          )}
        </div>
      </div>
    `;
  },
};

export const makeOptionItem = (option, selected_value, is_frame_select) => {
  if (is_frame_select) {
    const name = NessLabsSettingS.numberToLetter(option);
    return html`
      <li
        class="select-option selector_item i_item ${UtilTmplS.selectIf(option == selected_value)}"
        data-name="${name}"
        data-value="${option}"
        data-frame_option="${option}"
      >
        ${name}
      </li>
    `;
  }

  const { motion_id, name } = option;
  return html`
    <li
      class="select-option selector_item i_item ${UtilTmplS.selectIf(motion_id === selected_value)}"
      data-name="${name}"
      data-value="${motion_id}"
    >
      ${name}
    </li>
  `;
};

export const optionsHtml = ({ options, selected_value, type, is_frame_select }) => {
  return html` <div class="select-options" data-type="${type}">
    ${NessCustomMakerFrameShareTmplS.iscroll_wrapper_tmpl(
      go(
        options,
        strMap((option) => makeOptionItem(option, selected_value, is_frame_select)),
      ),
      {
        offsetY: 0,
      },
    )}
  </div>`;
};

const MotionFilter = {
  filterAvailable: (motions, availables) => {
    return go(
      motions,
      filter((motion) => availables?.some(({ id }) => id === motion.motion_id)),
      map((motion) => {
        const available_frame = find(({ id }) => id === motion.motion_id, availables);
        return { ...motion, available_frame };
      }),
    );
  },

  getAvailableMotions: (allMotions, availableMotions) => {
    return {
      emotions: MotionFilter.filterAvailable(allMotions.emotion, availableMotions.emotion),
      actions: MotionFilter.filterAvailable(allMotions.action, availableMotions.action),
      weapons: MotionFilter.filterAvailable(allMotions.weapon, availableMotions.weapon),
    };
  },
};

export const setting = (data) => {
  const is_mobile = MShopUtilF.isMobile();
  const { available_motions, selected_motions, motions } = data;
  const { emotions, actions, weapons } = MotionFilter.getAvailableMotions(motions, available_motions);
  const motion_section = [
    [NessLabsSettingConstantS.MOTION_TYPES.WEAPON, selected_motions.weapon, weapons],
    [NessLabsSettingConstantS.MOTION_TYPES.ACTION, selected_motions.action, actions],
    [NessLabsSettingConstantS.MOTION_TYPES.EMOTION, selected_motions.emotion, emotions],
  ];
  return html`
    <div class="avatar-setting" data-fx-json="${$dataStr(data)}">
      ${is_mobile ? makeInfoHtml() : ''}
      <div class="avatar-setting__content">
        ${makePreviewHtml(data)}
        <div class="avatar-setting__controls">
          ${!is_mobile ? makeInfoHtml() : ''}
          <div class="motion-controls">
            ${strMap(
              ([type, value, options]) => ControlSection.make(type, value, options, is_mobile),
              motion_section,
            )}
          </div>
        </div>
      </div>

      <div class="avatar-setting__footer">
        <button class="cancel-button">Cancel</button>
        <button class="generate-button">Generate</button>
      </div>
    </div>
  `;
};

export const makeSelectedOptionHtml = ({ value, name, frame_option }) => {
  const display_name = frame_option ? NessLabsSettingS.numberToLetter(value) : name;

  return html` <div
    class="select-selected ${frame_option ? 'frame_option' : ''}"
    data-value="${value}"
    data-name="${display_name}"
  >
    ${display_name}
  </div>`;
};

export const makePreviewHtml = (data) => {
  const { maple_image_url, selected_motions } = data;
  const motioned_image_url = NessLabsS.makeCharactersMotionUrl(maple_image_url, selected_motions);

  return html` <div class="avatar-setting__preview" data-fx-json="${$dataStr(data)}">
    <div class="character-container">
      <canvas class="my-character-setting" data-src="${motioned_image_url}"></canvas>
    </div>
  </div>`;
};

const makeInfoHtml = () => html`
  <div class="info">
    <i class="info-icon"></i>
    ${ET('labs::setting::info')}
  </div>
`;
